export const enum AssetsMutationsNames {
    SetAssets = "setAssets",
    SetSelected = "setSelectedAsset",
    SetError = "setAssetsError",
    ResetState = "resetState",
}

export const enum AssetsActionsNames {
    FetchAssetsList = "fetchAssetsList",
    SetSelected = "setSelectedAsset",
    SetAssets = "setAssets",
    ResetState = "resetAssetsState",
}

export const enum AssetsGettersNames {
    AssetsList = "assetsList",
    SelectedAsset = "selectedAsset",
    AssetsError = "error",
}
